import React, { useEffect, useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Button } from "@gw/web-basic-components";
import { useBusinessConfig } from "../../../utils/business-config";
import ColAutoComplete from "./colAutoComplete";
import ColDatePicker from "./colDatePicker";
import ColSelect from "./colSelect";
import type {
  ColSearchMatchValue,
  ColSearchParam,
  ColSearchProps,
} from "./dto";
import styles from "./index.module.less";

/**
 * 列名精准匹配
 */
const ColSearch = (props: ColSearchProps) => {
  const { apis, useRequest } = useBusinessConfig();
  const { showOptions = true, matchType = "Like" } = props;

  const dropDownRef = useRef<any>(null);

  const [val, setVal] = useState<ColSearchMatchValue>();

  /**
   * 搜索按钮点击回调
   */
  const handleSearchClick = () => {
    const params: ColSearchParam = {
      column: props?.requestConfig?.changeColName || props.colIndex,
      matchType: matchType,
      matchValue: val,
    };
    params.matchType = matchType;
    if (matchType === "Select") params.matchType = "Equals";
    if (typeof val === "string") params.matchValue = val.trim();
    else if (Array.isArray(val)) {
      params.matchValue = [
        val[0].format("YYYY-MM-DD HH:mm:ss"),
        val[1].format("YYYY-MM-DD HH:mm:ss"),
      ];
    } else params.matchValue = val;
    props.onChange(params);
    props.onClose();
  };
  /**
   * 重置：移除此筛选项
   */
  const handleSearchReset = () => {
    if (props.baseParams[props.colIndex]) {
      setVal("");
      props.onChange(props.colIndex);
      props.onClose();
    }
  };
  /**
   * 关闭下拉菜单
   */
  const onClose = () => {
    removeListener();
    props.onClose();
  };
  /**
   * 监听mouseDown
   */
  const listenMouseDown = (e: Event) => {
    if (!dropDownRef.current) return;
    const eleList = document.querySelectorAll(".col_search");
    let inDrop = false;
    eleList.forEach((m) => {
      if (m.contains(e.target as Node)) {
        inDrop = true;
      }
    });
    const inIcon = document
      .getElementById(`${props.colIndex}_icon`)
      .contains(e.target as Node);
    if (dropDownRef.current?.contains(e.target) || inDrop || inIcon) {
      // console.log(`inside ${props.colIndex} click`);
    } else {
      // console.log(`outside ${props.colIndex} click`);
    }
  };
  /**
   * 监听滚动
   */
  const listenScroll = (e) => {
    e?.stopPropagation();
    e?.nativeEvent?.stopImmediatePropagation();
    if (e.target.className?.startsWith?.("ant-picker")) return;
    onClose();
  };
  /**
   * 注册事件
   */
  const addListener = () => {
    // console.log(`${props.colIndex}添加了监听事件,scroll,mousedown`);
    document.addEventListener("scroll", listenScroll, { capture: true });
    document.addEventListener("mousedown", listenMouseDown, {
      capture: true,
    });
  };
  /**
   * 移除事件
   */
  const removeListener = () => {
    document.removeEventListener("mousedown", listenMouseDown, true);
    document.removeEventListener("scroll", listenScroll, true);
  };

  /**
   * 控制监听事件
   */
  useEffect(() => {
    //每次都先移除监听事件
    removeListener();
    // 只有当前打开的dorpdown才允许添加监听事件
    if (props.colIndex === props.visible) {
      addListener();
    }

    return () => removeListener();
  }, [props.visible]);

  const renderSearch = () => {
    if (props.matchType === "Between")
      return (
        <ColDatePicker val={val} setVal={setVal} colIndex={props.colIndex} />
      );
    if (props.matchType === "Select")
      return (
        <ColSelect
          val={val}
          setVal={setVal}
          options={props.options}
          tableName={props.tableName}
          colIndex={props.colIndex}
          requestConfig={props.requestConfig}
          configProvider={{ apis, useRequest }}
        />
      );
    return (
      <ColAutoComplete
        val={val}
        setVal={setVal}
        tableName={props.tableName}
        showOptions={showOptions}
        colIndex={props.colIndex}
        requestConfig={props.requestConfig}
        configProvider={{ apis, useRequest }}
        extraParam={props.extraParam}
      />
    );
  };

  return (
    <div ref={dropDownRef} className={styles.wrapper}>
      {renderSearch()}
      <div className={styles.operation}>
        <Button shape="round" size="small" onClick={onClose}>
          关闭
        </Button>
        <Button shape="round" size="small" onClick={() => handleSearchReset()}>
          重置
        </Button>
        <Button
          type="primary"
          size="small"
          icon={<SearchOutlined />}
          shape="circle"
          onClick={() => handleSearchClick()}
        ></Button>
      </div>
    </div>
  );
};

export default ColSearch;
